<template>
  <div :class="['element-select', size]">
    <el-select class="select" v-model="value" v-bind="$attrs" v-on="$listeners">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'element-select',
  props: {
    size: {
      type: String,
      default: '',
    },
    val: {
      type: [Number, String],
      default: '',
    },
    options: {
      type: Array,
      default: () => {
        return [
          {
            value: 2023,
            label: 2023,
          },
          {
            value: 2022,
            label: 2022,
          },
          {
            value: 2021,
            label: 2021,
          },
          {
            value: 2020,
            label: 2020,
          },
          {
            value: 2019,
            label: 2019,
          },
          {
            value: 2018,
            label: 2018,
          },
          {
            value: 2017,
            label: 2017,
          },
          {
            value: 2016,
            label: 2016,
          },
        ];
      },
    },
  },
  data() {
    return {
      value: this.val !== null ? this.val : 2021,
    };
  },
  watch: {
    val(n) {
      this.value = n;
    },
    value(n) {
      this.$emit('val', n);
    },
  },
  mounted() {
    this.$emit('val', this.value);
  },
};
</script>

<style lang="less" scoped>
.element-select {
  &.middle {
    .el-select {
      width: 290px;
      height: 36px;
    }
  }

  /deep/.el-select {
    width: 90px;
    height: 24px;
    border-radius: 3px;

    .el-input,
    input {
      width: 100%;
      height: 100%;
    }

    .el-input__suffix,
    .el-input__suffix-inner {
      height: 24px;
    }

    .el-input__icon {
      position: relative;

      &.el-icon-arrow-up::before {
        position: absolute;
        top: 53%;
        transform: translateY(-55%);
        right: 5px;
        color: #fff;
        content: '';
      }

      &.el-icon-circle-close {
        /*transform: none;*/
        top: 14px;
      }

      &.is-reverse::before {
        top: 50%;
        right: 0;
      }
    }

    input {
      background: linear-gradient(
        0deg,
        rgba(0, 197, 250, 0.5) 0%,
        rgba(0, 197, 250, 0.48) 6%,
        rgba(0, 197, 250, 0.11) 100%
      );
      outline: none;
      border: none;
      color: #fff;
      font-size: 14px;
    }
  }
}
</style>
